import React from "react"
import { get, map, concat, clone, take } from "lodash"
import { Modal } from "react-bootstrap"
import { BaseSelect } from "components/atoms/input/select"
import store from "redux/store"
import {
  changeRegisterSheet,
  editRegisterSymbolSheet,
  RegisterSymbolStateType,
} from "redux/ducks/RegisterSymbol"

type Props = {
  isShow: boolean
  onHide: Function
  registerSymbol: RegisterSymbolStateType
  selectData: Array<object>
}

export const SymbolRegisterModal = (props: Props) => {
  const sheetList = map(
    props.registerSymbol.symbolSheetList.SheetList,
    (data: object, i: number) => {
      return { id: i, name: get(data, "SheetName") }
    }
  )

  const execute = () => {
    const _symbolSheet = clone(props.registerSymbol.symbolSheet)
    _symbolSheet.SymbolList = take(
      concat(props.registerSymbol.symbolSheet.SymbolList, props.selectData),
      50
    )
    store.dispatch(editRegisterSymbolSheet(_symbolSheet))
  }
  return (
    <Modal
      show={props.isShow}
      onHide={() => props.onHide(false)}
      dialogClassName="symbol-register-modal"
    >
      <Modal.Header>
        <div className="modal-header">
          <div className="header-title">銘柄登録</div>
          <div className="header-nav-icon-col">
            <div
              className="header-icon ripple"
              data-izimodal-close
              onClick={() => props.onHide(false)}
            >
              <i className="material-icons">close</i>
            </div>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="favorite-contents">
          <BaseSelect
            option={sheetList}
            value={props.registerSymbol.symbolSheet.SheetNo}
            onChange={(id: number) =>
              store.dispatch(changeRegisterSheet(String(id)))
            }
          />
          <div
            className="btn btn-primary btn-shaped"
            onClick={() => {
              execute()
              props.onHide()
            }}
          >
            登録
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-bottom-btn-row">
          <div
            className="btn btn-outline ripple"
            onClick={() => props.onHide(false)}
          >
            閉じる
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
